import api from './api';

export default {
    async getDataReportUser(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.name) params.name = filters.name;
                if (filters.email) params.email = filters.email;
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.socialNumber) params.socialNumber = filters.socialNumber;
            }
            
            // Paginação - page padrão é 0 conforme especificação da API
            if (pagination && typeof pagination === 'object') {
                params.page = pagination.page !== undefined ? pagination.page : 0;
                if (pagination.size !== undefined) params.size = pagination.size;
            } else {
                // Se não houver objeto de paginação, usar valores padrão
                params.page = 0;
            }
            
            const response = await api.get('/report/user', {
                method: 'GET',
                headers,
                params
            });
            
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de usuários:', error);
            return {
                userList: [],
                totalElements: 0,
                totalPages: 0,
                currentPage: 0,
                pageSize: pagination?.size || 10
            };
        }
    },
    async getDataReportUserExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.name) params.name = filters.name;
                if (filters.email) params.email = filters.email;
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.socialNumber) params.socialNumber = filters.socialNumber;
            }
            
            const response = await api.get('/report/user/export', {
                method: 'GET',
                headers,
                params,
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de usuários:', error);
            throw error;
        }
    },
    async getDataEnrols(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };

            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.status) params.status = filters.status;
                if (filters.name) params.name = filters.name;
                if (filters.userName) params.userName = filters.userName;
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            // Paginação
            if (pagination && typeof pagination === 'object') {
                if (pagination.page !== undefined) params.page = pagination.page;
                if (pagination.size !== undefined) params.size = pagination.size;
                if (pagination.sort) params.sort = pagination.sort;
            }

            const response = await api.get('/report/enrol', {
                headers,
                params
            });

            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de matrículas:', error);
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataEnrolsExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.status) params.status = filters.status;
                if (filters.name) params.name = filters.name;
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }

            const response = await api.get('/report/enrol/export', {
                headers,
                params,
                responseType: 'blob'
            });

            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de matrículas:', error);
            throw error;
        }
    },    
    async getDataCourses(accessToken, searchParams = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Adicionar parâmetros de busca se fornecidos
            if (searchParams.userName) {
                params.name = searchParams.userName;
            }
            if (searchParams.courseName) {
                params.courseName = searchParams.courseName;
            }
            // Filtro por data
            if (searchParams.dateFrom) {
                params.dateFrom = searchParams.dateFrom;
            }
            if (searchParams.dateTo) {
                params.dateTo = searchParams.dateTo;
            }
            if (searchParams.pageNumber) {
                params.pageNumber = searchParams.pageNumber;
            }
            if (searchParams.pageSize) {
                params.pageSize = searchParams.pageSize;
            }
            
            console.log('getDataCourses params:', params);
            
            const response = await api.get('/report/course', {
                headers,
                params
            });
            
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de matrículas:', error);
            // Retornar estrutura vazia mesmo em caso de erro
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataCoursesExport(accessToken, searchParams = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };

            const params = {
                userName: searchParams.userName || '',
                courseName: searchParams.courseName || ''
            };
            console.log('Export endpoint params:', params);

            const response = await api.get('/report/course/export', {
                headers,
                params
            });

            console.log('Export endpoint URL:', '/report/course/export');
            console.log('Export endpoint headers:', headers);
            console.log('Export endpoint response:', response);

            return {
                content: Array.isArray(response.data) ? response.data : [],
                totalElements: Array.isArray(response.data) ? response.data.length : 0,
                totalPages: 1
            };
        } catch (error) {
            console.error('Export endpoint error:', error);
            console.error('Export endpoint error response:', error.response);
            throw error;
        }
    },
    async getDataOrder(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.status) params.status = filters.status;
                if (filters.name) params.name = filters.name;
                if (filters.userName) params.name = filters.userName; // Suporte para userName também
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            // Paginação
            if (pagination && typeof pagination === 'object') {
                if (pagination.page !== undefined) params.page = pagination.page;
                if (pagination.size !== undefined) params.size = pagination.size;
            }
            
            const response = await api.get('/report/order', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de vendas:', error);
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataOrderExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.status) params.status = filters.status;
                if (filters.name) params.name = filters.name;
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            const response = await api.get('/report/order/export', {
                method: 'GET',
                headers,
                params,
                responseType: 'blob' // Para receber arquivo
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de vendas:', error);
            throw error;
        }
    },
    async getDataNotification(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                // Filtro por nome do usuário/título
                if (filters.userName) params.userName = filters.userName;
                if (filters.title) params.title = filters.title;
                
                // Filtro por data
                if (filters.dateFrom) params.dateFrom = filters.dateFrom;
                if (filters.dateTo) params.dateTo = filters.dateTo;
            }
            
            const response = await api.get('/report/notification', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de avisos:', error);
            // Retornar estrutura vazia mesmo em caso de erro
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataInquiry(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.title) params.title = filters.title;
                if (filters.userName) params.userName = filters.userName;
                if (filters.userEmail) params.userEmail = filters.userEmail;
            }
            
            // Paginação
            if (pagination && typeof pagination === 'object') {
                if (pagination.page !== undefined) params.page = pagination.page;
                if (pagination.size !== undefined) params.size = pagination.size;
            }
            
            const response = await api.get('/report/inquiry', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de dúvidas:', error);
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataInquiryExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.title) params.title = filters.title;
                if (filters.userName) params.userName = filters.userName;
                if (filters.userEmail) params.userEmail = filters.userEmail;
            }
            
            const response = await api.get('/report/inquiry/export', {
                method: 'GET',
                headers,
                params,
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de dúvidas:', error);
            throw error;
        }
    },
    async getDataForum(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.userName) params.userName = filters.userName;
                if (filters.title) params.title = filters.title;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            // Paginação
            if (pagination && typeof pagination === 'object') {
                if (pagination.page !== undefined) params.page = pagination.page;
                if (pagination.size !== undefined) params.size = pagination.size;
            }
            
            const response = await api.get('/report/forum', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de fórum:', error);
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataForumExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.userName) params.userName = filters.userName;
                if (filters.title) params.title = filters.title;
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            const response = await api.get('/report/forum/export', {
                method: 'GET',
                headers,
                params,
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de fórum:', error);
            throw error;
        }
    },
    async getDataQuiz(accessToken, filters = {}, pagination = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {};
            
            // Filtros
            if (filters && typeof filters === 'object') {
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.userName) params.userName = filters.userName;
                if (filters.gradeFilter !== undefined) {
                    // gradeFilter pode ser um intervalo (ex: "0-2", "2.5-4") ou status ("aprovado", "reprovado")
                    // ou um número decimal. Se for um intervalo/status, manter como string
                    if (typeof filters.gradeFilter === 'string' && 
                        (filters.gradeFilter.includes('-') || 
                         filters.gradeFilter === 'aprovado' || 
                         filters.gradeFilter === 'reprovado')) {
                        params.gradeFilter = filters.gradeFilter;
                    } else {
                        // Se for um número, converter para decimal
                        params.gradeFilter = typeof filters.gradeFilter === 'string' 
                            ? parseFloat(filters.gradeFilter) 
                            : filters.gradeFilter;
                    }
                }
                if (filters.score !== undefined && filters.gradeFilter === undefined) {
                    // score pode ser um intervalo ou status
                    if (typeof filters.score === 'string' && 
                        (filters.score.includes('-') || 
                         filters.score === 'aprovado' || 
                         filters.score === 'reprovado')) {
                        params.gradeFilter = filters.score;
                    } else {
                        // Se for um número, converter para decimal
                        params.gradeFilter = typeof filters.score === 'string' 
                            ? parseFloat(filters.score) 
                            : filters.score;
                    }
                }
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            // Paginação
            if (pagination && typeof pagination === 'object') {
                if (pagination.page !== undefined) params.page = pagination.page;
                if (pagination.size !== undefined) params.size = pagination.size;
            }
            
            const response = await api.get('/report/quiz', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter relatórios de quizzes:', error);
            return {
                content: [],
                totalElements: 0,
                totalPages: 0
            };
        }
    },
    async getDataQuizExport(accessToken, filters = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            
            const params = {};
            if (filters && typeof filters === 'object') {
                if (filters.courseName) params.courseName = filters.courseName;
                if (filters.userName) params.userName = filters.userName;
                if (filters.gradeFilter !== undefined) {
                    // gradeFilter pode ser um intervalo (ex: "0-2", "2.5-4") ou status ("aprovado", "reprovado")
                    // ou um número decimal. Se for um intervalo/status, manter como string
                    if (typeof filters.gradeFilter === 'string' && 
                        (filters.gradeFilter.includes('-') || 
                         filters.gradeFilter === 'aprovado' || 
                         filters.gradeFilter === 'reprovado')) {
                        params.gradeFilter = filters.gradeFilter;
                    } else {
                        // Se for um número, converter para decimal
                        params.gradeFilter = typeof filters.gradeFilter === 'string' 
                            ? parseFloat(filters.gradeFilter) 
                            : filters.gradeFilter;
                    }
                }
                if (filters.startDate) params.startDate = filters.startDate;
                if (filters.endDate) params.endDate = filters.endDate;
            }
            
            const response = await api.get('/report/quiz/export', {
                method: 'GET',
                headers,
                params,
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao exportar relatório de quizzes:', error);
            throw error;
        }
    },
    async getDataQuizAnswer(accessToken, tokenProgress) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const params = {
                tokenProgress: tokenProgress
            };
            
            const response = await api.get('/report/quiz/answer', {
                method: 'GET',
                headers,
                params
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter respostas do quiz:', error);
            throw error;
        }
    },
    async deleteQuizProgress(accessToken, tokenProgress) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            
            const response = await api.delete(`/progress/quiz/${tokenProgress}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar progresso do quiz:', error);
            throw error;
        }
    },
    async getDataOrderSummary(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get('/report/order/summary', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter resumo de pedidos:', error);
            throw error;
        }
    },
    async getDataReport() {
        try {
            const params = this.searchTerm ? {
                userName: this.searchTerm,
                courseName: this.searchTerm
            } : {};

            console.log('Params being sent to API:', params);

            const response = await api.getDataCourses(this.token, params);
            console.log('API response:', response);

            this.usersInfo = response.content;
            this.hasReady = true;

            console.log('Users Info:', this.usersInfo);

            this.userFiltered = this.usersInfo.filter(course => {
                const matchesUserName = course.userName.toLowerCase().includes(this.searchTerm.toLowerCase());
                const matchesCourseName = course.courseName.toLowerCase().includes(this.searchTerm.toLowerCase());
                
                console.log(`Checking course: ${course.courseName}, User: ${course.userName}, Matches: ${matchesUserName || matchesCourseName}`);
                
                return matchesUserName || matchesCourseName;
            });

            console.log('Filtered Results:', this.userFiltered);

            this.totalEnrols = this.userFiltered.length; 
        } catch (error) {
            console.error('Error Report Users', error);
            this.hasReady = true;
        }
    }
}
